<section class="fullHeight flex sec bg">
    <div class="pad  fullWidth">
        <div class="flex">
            <div style="flex: 1;" class="flex">
                <div style="flex-direction: column;" class="formCar flex">
                    <div class="passwordText">
                        <h1 style="font-size: 3rem;">Reset Password</h1>
                        <p style="text-align: center;">Enter the email you registered with</p>
                    </div>
                    <br>
                    <form [formGroup]="signInForm" class="flex" style="flex-direction: column;height:100%;">
                        <mat-form-field>
                            <mat-label> Email</mat-label>
                            <input type="email" [email]="true" formControlName="email" matInput>
                        </mat-form-field>
                        <button type="button" style="width: 40%;" (click)="forgetPassword()" color="accent"
                            mat-flat-button>Proceed
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
